export default "__VITE_ASSET__BBHeb$R8__"